export default __webpack_public_path__ + "static/media/jenkins_icon.1803c8ac.png";